import { render, staticRenderFns } from "./copy-table-data.vue?vue&type=template&id=7c9b889a&scoped=true"
import script from "./copy-table-data.vue?vue&type=script&lang=js"
export * from "./copy-table-data.vue?vue&type=script&lang=js"
import style0 from "./copy-table-data.vue?vue&type=style&index=0&id=7c9b889a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9b889a",
  null
  
)

export default component.exports